module.exports = __webpack_public_path__ + "img/downAppCode4.e2650818.png";